import styled from 'styled-components';

const ChatItemActions = styled.div`
  display: inline-flex;
  box-sizing: border-box;
  column-gap: 4px;
  border-radius: 12px;
  padding: 1px;
  height: 24px;
  align-items: center;
  background-color: var(--elevation-low);
  border: 1px solid var(--border-muted);
`;

export { ChatItemActions };
